import store from '../../config/configureStore';

export const countArresteesErrors = (ptsIncPersonId) => {
  let currentIncidentId = parseInt(store.store.getState().incident.ptsIncidentId);
  let validationErrors = store.store.getState().incident.validationErrors;
  let currentOffenseId = store.store.getState().incident.offensesOffenseForm.ptsOffenseId;

  const errorObj = validationErrors.find((error) => error.ptsIncidentId === currentIncidentId);

  if (!errorObj?.errors?.arresteesErrors) {
    return 0;
  }
  let errorCount = 0;

  for (let error of errorObj.errors.arresteesErrors) {
    if (error.ptsIncPersonId === ptsIncPersonId && error.ptsOffenseId === currentOffenseId) {
      errorCount++;
    }
  }
  return errorCount;
};
